import _ from "lodash";

const radarS4 = function() {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
};

const generateGuid = function() {
  return radarS4() + radarS4() + radarS4() + radarS4();
};

export { generateGuid };



// WEBPACK FOOTER //
// ./src/modules/guid.js